<template>
  <div style="height:100%" class="advertising">
    <div class="manage">
      <div class="content">
        <div class="operation">
          <el-row :gutter="20" style="width:100%">
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <el-button
                  type="primary"
                  :round="false"
                  size="small"
                  icon="el-icon-plus"
                  @click="dialogFormVisible = true"
                >
                  <span>添加幻灯片</span>
                </el-button>
              </div>
            </el-col>
            <el-col :span="6" :offset="12">
              <div class="grid-content bg-purple seach">
                <el-dropdown trigger="click">
                  <span class="el-dropdown-link">
                    状态
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>黄金糕</el-dropdown-item>
                    <el-dropdown-item>狮子头</el-dropdown-item>
                    <el-dropdown-item>螺蛳粉</el-dropdown-item>
                    <el-dropdown-item>双皮奶</el-dropdown-item>
                    <el-dropdown-item>蚵仔煎</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-input
                  placeholder="请输入内容"
                  v-model="screenInput"
                  clearable
                  size="small"
                ></el-input>
                <el-button type="primary" size="small">搜索</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="operation" style="margin-top:30px;">
          <el-row :gutter="20" style="width:100%">
            <el-col :span="6">
              <div
                class="grid-content bg-purple seach"
                style="justify-content:flex-start;"
              >
                <el-input
                  placeholder="请输入内容"
                  v-model="screenInput"
                  clearable
                  size="small"
                ></el-input>
                <el-button type="primary" size="small">搜索</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="advertisingList">
          <template>
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="date" label="编号" width="140">
              </el-table-column>
              <el-table-column prop="name" label="标题" width="140">
              </el-table-column>
              <el-table-column prop="address" label="位置" width="140">
              </el-table-column>
              <el-table-column prop="date" label="小程序链接" width="300">
              </el-table-column>
              <el-table-column prop="name" label="图片(750*375)" width="190">
              </el-table-column>
              <el-table-column prop="address" label="公众号链接" width="190">
              </el-table-column>
              <el-table-column prop="date" label="是否可用" width="190">
              </el-table-column>
              <el-table-column prop="date" label="操作"> </el-table-column>
            </el-table>
          </template>
        </div>
      </div>
    </div>
    <el-dialog title="添加幻灯片" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="位置" :label-width="formLabelWidth">
          <el-row :gutter="10">
            <el-col :span="20"
              ><div class="grid-content bg-purple">
                <el-input
                  v-model="form.name"
                  autocomplete="off"
                  size="small"
                ></el-input></div
            ></el-col>
            <el-col :span="3"
              ><div class="grid-content bg-purple-light">
                <el-button size="small">位置选择</el-button>
              </div></el-col
            >
          </el-row>
        </el-form-item>
        <el-form-item label="标题" :label-width="formLabelWidth">
          <el-row :gutter="10">
            <el-col :span="20"
              ><div class="grid-content bg-purple">
                <el-input
                  v-model="form.name"
                  autocomplete="off"
                  size="small"
                ></el-input></div
            ></el-col>
            <el-col :span="3"
              ><div class="grid-content bg-purple-light">
                <!-- <el-button size="small">位置选择</el-button> -->
              </div></el-col
            >
          </el-row>
        </el-form-item>
        <el-form-item label="小程序链接" :label-width="formLabelWidth">
          <el-row :gutter="10">
            <el-col :span="20"
              ><div class="grid-content bg-purple">
                <el-input
                  v-model="form.name"
                  autocomplete="off"
                  size="small"
                ></el-input></div
            ></el-col>
            <el-col :span="3"
              ><div class="grid-content bg-purple-light">
                <el-button size="small">选择链接</el-button>
              </div></el-col
            >
          </el-row>
        </el-form-item>
        <el-form-item label="图片(750*375)" :label-width="formLabelWidth">
          <div class="img"></div>
        </el-form-item>
        <el-form-item label="公众号链接" :label-width="formLabelWidth">
          <el-row :gutter="10">
            <el-col :span="20"
              ><div class="grid-content bg-purple">
                <el-input
                  v-model="form.name"
                  autocomplete="off"
                  size="small"
                ></el-input></div
            ></el-col>
            <el-col :span="3"
              ><div class="grid-content bg-purple-light">
                <el-button size="small">选择链接</el-button>
              </div></el-col
            >
          </el-row>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-row :gutter="10">
            <el-col :span="3"
              ><div class="grid-content bg-purple">
                <el-input
                  v-model="form.name"
                  autocomplete="off"
                  size="small"
                ></el-input></div
            ></el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="状态 " :label-width="formLabelWidth">
          <template>
            <el-radio v-model="radio" label="1">显示</el-radio>
            <el-radio v-model="radio" label="2">隐藏</el-radio>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  data() {
    return {
      radio: "1",
      screenInput: "",
      screenValue: "",
      newRow: {},
      showEdit: false,
      showadvertising: false,
      idx: 1,
      nowIDx: 0,
      value: "",
      input: "",
      page: "1",
      dialogFormVisible: false,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      formLabelWidth: "160px",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄"
        }
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
el-table{
  height: calc(100% - 20px);
}
.manage {
  height: 100%;
  padding-left: 22px;
  padding-right: 72px;
  position: relative;
  .content {
    overflow: hidden;
    position: absolute;
    top: 0px;
    bottom: 26px;
    left: 22px;
    right: 70px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 30px;
    .operation {
      height: 36px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .seach {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      .el-input {
        width: 200px;
      }
    }
    .advertisingList {
      height: 100%;
      margin-top: 20px;
    }
  }
}
.setBox {
  padding-right: 100px;
  display: flex;
  flex-direction: row;
}
.img {
  width: 80px;
  height: 80px;
  background: #409eff;
}
</style>

<style lang="scss">
.advertising {
  .manage {
    .cell {
      text-align: center;
    }
  }
}
</style>
